import { useTranslation } from "react-i18next";
import type { Task } from "../api";
import { ddayText, ddayTone, taskDeadlineProgress } from "../lib/format";

export function TaskDeadline({ task, completedLabel = "완료" }: { task: Pick<Task, "startsOn" | "dueOn" | "status">; completedLabel?: "완료" | "종료" }) {
  const { t } = useTranslation();
  const deadline = taskDeadlineProgress(task);
  return <span className={`board-card-deadline ${deadline?.tone || ddayTone(task)}`}>
    {deadline && <span className="board-card-progress" role="progressbar" aria-label={t("tasks.scheduleProgress", { percent: deadline.percent })} aria-valuemin={0} aria-valuemax={100} aria-valuenow={deadline.percent}><i style={{ width: `${deadline.percent}%` }} /></span>}
    <span className="mono dday">{task.status === "COMPLETED" ? completedLabel : ddayText(task)}</span>
  </span>;
}
